module.exports = __webpack_public_path__ + "img/yjbged.8c69d0c3.png";